<div class="navbar navbar-expand-lg d-flex justify-content-between height-lock p-0" id="navBar"
  *ngIf="navBarItems && navBarItems.length > 0">
  <div class="col-3 d-flex align-items-center">
    <button type="button" class="btn btn-clear skip-main position-absolute" id="skipBtn" (click)="skipToMain()">Skip
      to main content
    </button>

    <div class="col-auto p-0 logo d-flex align-items-center">
      <button id="navBarToggleBtn" class="navbar-toggler p-1 border-0" type="button" data-toggle="offcanvas"
        data-target="#navbar" aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation"
        (click)="toggleMenu()">
        <span class="navbar-toggler-icon">
          <span class="material-icons-outlined p-1" aria-hidden="true">
            menu
            </span>
        </span>
      </button>
      <img src="https://frostdesignsystem.learningmate.co/assets/images/logo/frost-align.svg" class="img-fluid" alt="Frost Align Logo">
    </div>
    <div class="col-auto p-0">
      <app-platform-switch></app-platform-switch>
    </div>
  </div>

  <div class="col-auto height-lock">
    <nav class="navbar-collapse offcanvas-collapse" [ngClass]="{'open': openNav}" id="navbar"
      aria-label="Global navigation">
      <ul class="navbar-nav">
        <ng-container *ngFor="let item of navBarItems">
          <li *ngIf="item.hasPermission" class="nav-item px-1 mr-2 position-relative"
            [ngClass]="{'dropdown': item.path==='NA' && item.hasPermission, 'active': currentItem===item.name}">
            <a class="nav-link position-relative" *ngIf="item.path!=='NA'" [routerLink]="[item.path]"
              (click)="onNavItemSelected(item.name)" target="_self" id="{{'nav_item_'+item.name}}">{{ item.name }}
              <span class="sr-only sr-only-focusable" *ngIf='currentItem===item.name'>current page</span>
            </a>

            <button type="button" *ngIf="item.path==='NA' && item.children && item.children.length > 0"
              class="nav-link btn btn-clear dropdown-toggle position-relative pr-3" id="{{ item.name }}Btn"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ item.name }}</button>
            <div class="dropdown-menu p-0" aria-labelledby="{{ item.name }}Btn"
              *ngIf="item.children && item.children.length > 0">
              <ng-container *ngFor="let subItem of item.children">
                <a class="dropdown-item" href="#" *ngIf="subItem.hasPermission && subItem.path!=='NA'"
                  [ngClass]="currentItem===subItem.name?'active':''"
                  [routerLink]="[subItem.path!=='NA'?subItem.path:'']" (click)="onNavItemSelected(item.name)"
                  [attr.disabled]="!subItem.active" target="_self">{{ subItem.name }}
                  <span class="sr-only sr-only-focusable" *ngIf='currentItem===subItem.name'>current page
                  </span>
                </a>
              </ng-container>
            </div>

        </ng-container>
      </ul>
    </nav>
  </div>

  <div class="col-3 d-flex justify-content-end align-items-center height-lock pr-3" id="foot">
    <div class="col-auto p-0 d-flex align-items-center">
      <div class="col-auto px-0 height-lock" id="tenantSwitch">

      </div>

      <div class="col notify height-lock d-flex justify-content-end align-items-center pr-4">
        <div class="col-auto p-0" *ngIf="showNotification">
          <button type="button" id="notificationBtn"
            class="d-inline-block btn btn-alert tooltip bottom position-relative btn-notification"
            [attr.aria-label]="(pending && pending.length > 0 || notifyCount && notifyCount > 0) ? 'you have unread notifications' : 'Notification '"
            data-tooltip="Notification" (click)="notifications();">
            <span class="material-icons-outlined font-6x" aria-hidden="true">
              notifications
              </span>
            <span class="notify-on position-absolute"
              *ngIf="(pending && pending.length > 0 || notifyCount && notifyCount > 0)">
            </span>
          </button>
        </div>

        <div class="col-auto p-0 profile" [ngClass]="showNotification ?'':''" id="divProfile">
          <div class="dropdown" [ngClass]="showDropdown ?'show':''">
            <button
              class="dropdown-toggle dropdown-custom ml-1 p-0 d-inline-block user-avatar text-uppercase position-relative"
              id="dropdownMenuLink" aria-haspopup="true" aria-controls="profileMenu"
              data-display="static" [attr.aria-label]="'Logged in as '+userName+''" (click)="selectProfileMenu()">{{nameInitials}}</button>

            <div class="dropdown-menu dropdown-menu-right p-0" id="profileMenu" role="menu" [ngClass]="showDropdown ?'show':''">
                  <a class=" dropdown-item btn" target="_blank" [attr.href]="getURL('report')" (click)="toggleDrpDwn()" role="menuitem" rel="noopener">Report
              Issue <span class="sr-only">opens in a new window</span></a>

              <a class="dropdown-item btn" target="_blank" [attr.href]="getURL('help')" (click)="toggleDrpDwn()" rel="noopener" role="menuitem">Help Center
                <span class="sr-only">opens in a new window</span></a>

              <button class="dropdown-item btn" id="publicWebsiteeBtn" role="menuitem" (click)="goToPublicWebsite()">
                Public Website <span class="sr-only">opens in a new window</span>
                <em class="material-icons-outlined pl-3 font-4x" aria-hidden="true">open_in_new</em>
              </button>

              <button class="dropdown-item btn" id="myprofileBtn" (click)="onUserProfileClick()" role="menuitem">
                My Profile
              </button>

              <button class="dropdown-item btn" id="logoutBtn" role="menuitem" [routerLink]="['/']"
                (click)="logout()">Logout</button>

            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</div>